import { cn } from '../lib/utils.ts';

export function ProjectName({
  isHome,
  className,
}: {
  isHome: boolean;
  className?: string;
}) {
  const classes = cn(
    'inline-block text-base font-bold tracking-[-0.035em]',
    className,
  );
  return isHome ? (
    <p className={classes}>d-cards</p>
  ) : (
    <a className={classes} href="/">
      d-cards
    </a>
  );
}
